import { useState, useMemo } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { useFetchResourcesByIdsQuery } from "@shared/services/queries";
import { ApiResponse } from "@shared/types";
import { Landing } from "@modules/landings/types";
import { AgreementPlan } from "@modules/agreementPlans/types";

export function useLandingsList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Landing>({
    resource: "v1/landing_admin/",
    filters: getQueryParams(),
    sorters: { ordering: "-id" },
  });

  const agreementIds = useMemo(
    () => [
      ...new Set(
        rows
          ?.map((landing) => landing.agreement)
          .filter((id): id is number => !!id)
      ),
    ],
    [rows]
  );

  const { data: agreements } = useFetchResourcesByIdsQuery<
    ApiResponse<AgreementPlan>
  >({
    resource: "v1/agreement_admin",
    ids: agreementIds,
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    agreements: agreements?.results,
    selectedRows,
    dataToExport,
    refetch,
    setSelectedRows,
    translate,
  };
}
